<template>
  <div class="pcd-field-time">
    <el-time-picker v-model="date" :value-format="valueFormat" :size="size" :disabled="useCurrent === true"></el-time-picker>
    <el-button :size="size" :type="useCurrent === true ? 'primary' : 'default'" @click="useCurrentDate()">使用“当前时间”</el-button>
  </div>
</template>

<script>
export default {
  name: 'time-picker-field',
  props: {
    property: { type: Object, required: true },
    size: { type: String, required: false, default: 'mini' },
    valueFormat: { type: String, required: false, default: 'HH:mm:ss' }
  },
  data () {
    return {
      date: '',
      useCurrent: false
    }
  },
  watch: {
    'property.value': {
      handler: function (val) {
        if (val === true) {
          this.useCurrent = true
        } else {
          this.date = val
        }
      },
      immediate: true
    },
    date () {
      this.property.value = this.date
      this.$emit('change')
    }
  },
  methods: {
    useCurrentDate () {
      this.useCurrent = this.useCurrent === true ? false : true
      if (this.useCurrent === true) {
        this.property.value = true
      } else {
        this.property.value = this.date
      }
      this.$emit('change')
    }
  }
}
</script>

<style>
.pcd-field-time{position:relative;}
.pcd-field-time>.el-date-editor{width:calc(100% - 120px);}
.pcd-field-time>.el-button{width:120px;position:absolute;top:0;right:0;border-radius:0 4px 4px 0;}
</style>
